import React from "react";
import styled from "@emotion/styled";
import { Colors } from "./components/colors";
import Footer from "./components/footer.jsx";
import NavBar from "./components/navbar.jsx";
import { withTranslation } from 'react-i18next';

class PageNotFound extends React.Component {
  constructor(props) {
    // Initialize mutable state
    super(props);
    this.state = {
      placeholder: [],
    };
  }

  render() {
    // This line automatically assigns this.state.imgUrl to the const variable imgUrl
    // and this.state.owner to the const variable owner
    const { users } = this.state;
    // Render index
    const { i18n } = this.props;
    return (
      <MainCol dir={this.props.i18n.dir()}>
        <NavBar />
        <Farm>
          <h1>{this.props.t("404page_msg")}</h1>
          <Cowboy >
            <img width="40%" src="../static/images/cowboy.webp" 
            alt="Cowboy illustration for 404 page"
            style={{transform: i18n.language == 'ar' ? 'scaleX(-1)' : 'none',}} />
          </Cowboy>
        </Farm>
        <Footer />
      </MainCol>
    );
  }
}
export default  withTranslation()(PageNotFound);

// Create a flex column display div
const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
`;

const MainCol = styled(FlexCol)`
  justify-content: space-between;
  height: 100vh;
`;

// Create a flex row display div
const Cowboy = styled.div`
  display: contents;
`;

// Create a flex column display div
const Farm = styled.div`
  justify-content: space-between;
  background: ${Colors.fucci};
  display: flex;
  flex-direction: row-reverse;
  height: 100%;
  padding-top:100px;
`;
